<div class="all-part">
  <app-case-stakeholders-filter (addNewType)="addNewType($event.type)"
    (filterByType)="filterByType($event)" [caseId]="case.id" class="filter-part"></app-case-stakeholders-filter>
  <app-case-stakeholders-table #caseStakeholdersTable [caseId]="case.id" class="table-part"></app-case-stakeholders-table>
</div>
